<template>
  <div class="d-print-none">
    <v-navigation-drawer
      color="backgroundLight"
      right
      v-if="$auth.isAuthenticated"
      :mini-variant="!$store.state.show_right_nav_bar"
      width="390"
      mini-variant-width="40"
      app
    >
      <v-row no-gutters class="fill-height">
        <v-navigation-drawer color="backgroundLight" fixed right mini-variant mini-variant-width="40">
          <v-list dense nav>
            <v-list-item-group color="primary">
              <v-list-item
                dense
                v-for="(tab, index) in tabs"
                :key="`${tab.id}_${index}`"
                class="nav-items"
                @click="open_section(tab.id)"
                ><v-icon small>{{ tab.icon }}</v-icon>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-navigation-drawer>
        <v-card class="fxd-details-section pa-4" v-if="$store.state.show_right_nav_bar">
          <AlertsSection
            ref="alertsSection"
            @open-dialog="showAddNewAlertDialog($event)"
            @update-device-filter="updateDeviceFilter($event)"
            @set-update-alerts="setUpdateAlerts($event)"
            @set-update-active-alerts="setUpdateActiveAlerts($event)"
            :update_alerts="update_alerts"
            :update_active_alerts="update_active_alerts"
          />
        </v-card>
      </v-row>
    </v-navigation-drawer>
    <v-overlay class="layering" :value="dialog">
      <v-card
        :light="!this.$vuetify.theme.dark"
        class="pb-4"
        :style="`width: '500px'; max-height: 80vh; overflow:hidden`"
      >
        <div class="overlay-header">
          <div class="close-btn">
            <v-btn @click="closeDialog" fixed outlined color="primaryGrey" class="py-4" x-small>
              <v-icon small color="primaryGrey">mdi-close</v-icon>
            </v-btn>
          </div>
        </div>
        <div class="overlay-content px-6 pb-6 mb-6">
          <ScvAlertsTemplate
            :device_id="device_id"
            :update_alert="edit_alert"
            :alert="edit_alert_obj"
            @close="closeDialog($event)"
          />
        </div>
      </v-card>
    </v-overlay>
    <v-snackbar color="borderDark" v-model="snackbar" timeout="2000">{{ message }}</v-snackbar>
  </div>
</template>

<script>
import AlertsSection from "./AlertsSection.vue";
import ScvAlertsTemplate from "./ScvAlertsTemplate.vue";
import CustomToast from "./CustomToast.vue";
import { notification_grpc_services } from "../services/NotificationServices.js";

export default {
  name: "SideBar",
  props: { tabs: Array },
  data: () => ({
    page_config: null,
    network_error: false,
    current_section: null,
    dialog: false,
    message: null,
    snackbar: false,
    update_alerts: false,
    update_active_alerts: false,
    edit_alert: false,
    edit_alert_obj: null,
    update_device_filter: false,
  }),
  components: {
    AlertsSection,
    ScvAlertsTemplate,
    CustomToast,
  },
  watch: {},
  mounted() {
    this.page_config = this.$config;
    this.get_real_time_alerts();
    this.get_real_time_events();
  },
  methods: {
    changeTab(newTab) {
      this.$nextTick(() => {
        const alertsSection = this.$refs.alertsSection;
        alertsSection.current_tab = newTab;
      });
    },
    open_section(s) {
      this.$store.commit("toggle_right_nav_bar");
      this.current_section = s;
    },
    open_page(s) {
      this.$store.commit("clear_search");
      this.$store.commit("update_page_title", s);
    },
    showAddNewAlertDialog(alert) {
      this.update_alerts = false;
      if (alert) {
        this.edit_alert = true;
        this.edit_alert_obj = alert;
      } else {
        this.edit_alert = false;
        this.edit_alert_obj = null;
      }
      this.dialog = true;
    },
    setUpdateAlerts(val) {
      this.update_alerts = !!val;
    },
    setUpdateActiveAlerts(val) {
      this.update_active_alerts = !!val;
    },
    updateDeviceFilter(filter) {
      this.update_device_filter = filter;
    },
    closeDialog(event) {
      this.dialog = false;
      if (event && event.msg) {
        this.message = event.msg;
        this.snackbar = true;
        this.update_alerts = true;
      }
    },
    async get_real_time_alerts() {
      let alerts_stream;
      const startStream = () => {
        alerts_stream = notification_grpc_services.GetScvRealTimeAlertsStream();
        alerts_stream.on("data", (response) => {
          let formatted_response = response.toObject();
          //check if alert data is sent or alive ping
          if (formatted_response.alertData) {
            this.alert_notification(formatted_response.alertData);
          }
        });
        alerts_stream.on("error", (err) => {
          console.log("Error occurred: Realtime Alerts Stream", err);
          // Recursive call to restart the stream on error.
          // setTimeout(() => {
          //   startStream();
          // }, 10000);
        });
        alerts_stream.on("end", () => {
          console.log("Realtime Alerts Stream ended");
        });
      };
      startStream(); // Start the initial stream
    },
    async get_real_time_events() {
      let events_stream;
      // Assign events_enabled value from user_config.events_enabled if it exists, otherwise default to true
      let events_enabled =
        this.$store.state.user_config && this.$store.state.user_config.events_enabled !== undefined
          ? this.$store.state.user_config.events_enabled
          : true;
      const startStream = () => {
        events_stream = notification_grpc_services.GetScvRealTimeEventsStream();
        events_stream.on("data", (response) => {
          let formatted_response = response.toObject();
          if (formatted_response.eventData) {
            this.event_notification(formatted_response.eventData);
          }
        });
        events_stream.on("error", (err) => {
          console.log("Error occurred: Realtime Alerts Stream", err);
          // Recursive call to restart the stream on error.
          // setTimeout(() => {
          //   startStream();
          // }, 10000);
        });
        events_stream.on("end", () => {
          console.log("Realtime Events Stream ended");
        });
      };
      // Start the initial stream
      if (events_enabled == true) {
        startStream();
      }
    },
    alert_notification(alert_data) {
      let alertMessage = this.formatAlertMessage(alert_data);
      let alertType = alert_data.alert_type;
      let toasttype;
      if (alertType === "alert") {
        toasttype = "warning";
      } else if (alertType === "alarm") {
        toasttype = "error";
      }
      let title = `New ${alertType}:`;
      if (alert_data.alert_name) {
        title = `${title} ${alert_data.alert_name}`;
      } else {
        title = `${title} ${this.get_notification_title(alert_data.device_id)}`;
      }
      this.$toast[toasttype]({
        component: CustomToast,
        props: {
          title: title,
          message: alertMessage,
          type: alertType,
          router: this.$router,
          event_alert_data: alert_data,
          event_index: 0,
          show_nav_bar_status: this.$store.state.show_right_nav_bar,
          show_right_nav_bar: () => this.$store.commit("toggle_right_nav_bar"),
          switch_logs_tab: (tabId) => {
            // Call changeTab after the next DOM update (nextTick)
            this.$nextTick(() => {
              this.changeTab(tabId);
            });
          },
        },
      });
      this.update_active_alerts = true;
    },
    event_notification(event_data) {
      //check if installed device
      let devices = this.$store.state.devices;
      if (!devices) return;
      let device = devices.find((d) => d.DeviceID === event_data.deviceid);
      if (!device.DeviceStatus.toLowerCase().includes("installed")) return;

      let user_config = this.$store.state.user_config;
      //Check if user_config and events_disabled_deviceids exist and is an array
      if (user_config && Array.isArray(user_config.events_disabled_deviceids)) {
        // Check if the current device is in the disabled event notification list
        if (user_config.events_disabled_deviceids.includes(event_data.deviceid)) return;
      }

      let events = event_data.eventsmessage.eventsmsgList || [];
      let timestampISO = event_data.timestampiso;
      events.forEach((event, index) => {
        let eventMessage = this.formatEventMessage(event, timestampISO);
        this.$toast.info({
          component: CustomToast,
          props: {
            title: `New Event : ${this.get_notification_title(event_data.deviceid)}`,
            message: eventMessage,
            type: "event",
            router: this.$router,
            event_alert_data: event_data,
            event_index: index,
            show_nav_bar_status: this.$store.state.show_right_nav_bar,
            show_right_nav_bar: () => this.$store.commit("toggle_right_nav_bar"),
            switch_logs_tab: (tabId) => {
              this.$nextTick(() => {
                this.changeTab(tabId);
              });
            },
          },
        });
      });
    },
    formatAlertMessage(alert) {
      let field = alert.field;
      // Append unit to trigger value based on field type
      let triggerValue = alert.trigger_value + (field.includes("Voltage") ? "V" : field.includes("Current") ? "A" : "");
      // Map trigger operator to descriptive text
      let triggerOperator =
        alert.trigger_operator === ">"
          ? "above"
          : alert.trigger_operator === "<"
            ? "below"
            : alert.trigger_operator || "";
      //Round actualValue to 2 decimal places and append unit
      let actualValue =
        alert.actual_value.toFixed(2) + (field.includes("Voltage") ? "V" : field.includes("Current") ? "A" : "");
      return `${field} has crossed ${triggerOperator} ${triggerValue} to ${actualValue}`;
    },
    formatEventMessage(event, timestampISO) {
      const eventType = event.eventtype || "Unknown Event";
      let timestamp = new Date(timestampISO);
      let message = `${eventType} occured on ${timestamp.toLocaleDateString()} at ${timestamp.toLocaleTimeString()}`;
      return message;
    },
  },

  computed: {
    device_id: function () {
      return this.$route.params.deviceId && this.update_device_filter ? this.$route.params.deviceId : null;
    },
    get_notification_title() {
      return (deviceId) => {
        const devices = this.$store.state.devices;
        if (!devices) return null;
        //find the details of current device
        const device = devices.find((d) => d.DeviceID === deviceId);
        return device ? device.TransformerName || device.AssetID || device.DeviceID : null;
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.image-border {
  // border: solid 1px var(--v-borderLight-base);
  border-radius: 5px;
}
.fxd-details-section {
  position: relative;
  width: 350px;
}

.close-btn {
  position: absolute;
  top: 1em;
  right: 0;
  z-index: 9;
  padding-right: 4em;
}

.overlay-header {
  position: relative;
  max-height: 40px;
  // overflow: auto;
}

.overlay-content {
  position: relative;
  top: 50px;
  max-height: 75vh;
  overflow: auto;
}
</style>
